import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, provide, inject, createRef } from 'intact-vue-next';
import { isNullOrUndefined } from 'intact-shared';
var id = 0;
export function createContext(defaultValue) {
  var injectionKey = "$Context-" + id++;
  var Provider = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Provider, _Component);
    function Provider() {
      var _context;
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
      _this.ref = createRef();
      return _this;
    }
    var _proto = Provider.prototype;
    _proto.init = function init(props) {
      var value = props && props.value;
      var ref = this.ref;
      ref.value = isNullOrUndefined(value) ? defaultValue : value;
      provide(injectionKey, ref);
      this.on('$receive:value', function (v) {
        return ref.value = v;
      });
    };
    return Provider;
  }(Component);
  Provider.template = providerTemplate;
  var Consumer = /*#__PURE__*/function (_Component2) {
    _inheritsLoose(Consumer, _Component2);
    function Consumer() {
      var _context2;
      var _this2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      _this2 = _Component2.call.apply(_Component2, _concatInstanceProperty(_context2 = [this]).call(_context2, args)) || this;
      _this2.ref = inject(injectionKey, createRef(defaultValue));
      return _this2;
    }
    return Consumer;
  }(Component);
  Consumer.template = consumerTemplate;
  function useContext() {
    return inject(injectionKey, createRef(defaultValue));
  }
  return {
    Provider: Provider,
    Consumer: Consumer,
    useContext: useContext
  };
}
function providerTemplate() {
  return this.$props.children;
}
function consumerTemplate() {
  var ref = this.ref;
  var props = this.$props;
  var value = ref && ref.value || props && props.value;
  return this.$props.children(value);
}
// Maybe like legency context api of React
// Error: Can not use it in multiple instances.
// export function Context<T = any>(defaultValue?: T) {
// let data: T | undefined;
// function Provider({value, children}: Props<ProviderProps<T>>) {
// data = value;
// return children; 
// }
// function Consumer({children}: Props<{}>) {
// return (children as unknown as Function)(data);
// }
// return {Provider, Consumer};
// }